import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransferParametersDialogComponent } from 'src/app/components/dialogs/audiences/transfer-parameters-dialog/transfer-parameters-dialog.component';
import { Audience, Transfer, TransferCreationRequest } from 'src/app/models/services/audience';

// Based on: https://darchuk.net/2019/01/11/angular-making-a-modal-service-by-extending-ngbmodal/
@Injectable({
  providedIn: 'root'
})
export class TransferParametersDialogService {
  lastErrorCloseResult: string;

  constructor(private modalService: NgbModal) { }

  public show = (audience: Audience, transfer: Transfer, acceptCallback: (data: TransferCreationRequest) => void, rejectCallback?: () => void): void => {    
    var ref = this.modalService.open(TransferParametersDialogComponent, { size: 'xl' });
    var output: TransferCreationRequest;

    // Get the OkDialog from the NgbModal object  
    let dialog: TransferParametersDialogComponent = ref.componentInstance as TransferParametersDialogComponent;
    
    // Set the dialog's properties
    dialog.audience = audience;
    dialog.transfer = transfer;
    dialog.accept = (data: TransferCreationRequest) => {
      output = data;
      ref.close(1);
    };

    dialog.dismiss = () => {
      ref.dismiss(2);
    };

    ref.result.then((result) => {
      switch (result) {
        case 1:
          acceptCallback(output);
          break;
        default:
          if (rejectCallback)
            rejectCallback();
      }
    }, (reason) => {
      if (rejectCallback)
        rejectCallback();
    })
  }
}
